import React from 'react';
import BenefitItem from './BenefitItem';

interface Benefit {
  title: string;
  imageUrl?: string;
  icon?: string;
}

interface BenefitsListProps {
  benefits: Benefit[];
}

const BenefitsList: React.FC<BenefitsListProps> = ({ benefits }) => {
  if (benefits.length === 0) {
    return null;
  }

  return (
    <div className='mt-[1.125rem] px-2 sm:px-0 min-w-0'>
      <p className='font-medium text-[12px] mb-2 leading-6 pt-0.5'>
        Inclusions
      </p>
      <div className='grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-5 gap-3 sm:gap-4 place-items-start text-center min-w-0 [&>*]:min-w-0'>
        {benefits.map((benefit, idx) => (
          <BenefitItem
            key={idx}
            title={benefit.title}
            imageUrl={benefit.imageUrl}
            icon={benefit.icon}
            maxLines={3}
          />
        ))}
      </div>
    </div>
  );
};

export default BenefitsList;
